import { Controller } from "@hotwired/stimulus";
import { dropzoneElement } from "../../components/dropzone";

export default class extends Controller {
  static targets = ["fileSelectionForm", "fileUploadContent"];

  connect() {
    window.$(this.element).on("hide.bs.modal", () => {
      this._resetModal();
    });
  }

  _resetModal() {
    if (this.hasFileSelectionFormTarget) {
      this.fileSelectionFormTarget.classList.remove("hidden");

      const dropzone = dropzoneElement(this.fileSelectionFormTarget.id);
      dropzone.removeAllFiles(true);
      dropzone.previewsContainer.innerHTML = "";
    }

    this.fileUploadContentTarget.innerHTML = "";
  }

  filesAdded() {
    this.fileSelectionFormTarget.classList.add("hidden");
  }
}
